import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP PROCEDURES.', '❌/✅ COMPARISONS.', 'READY SIMULATION DRILLS.', 'CLEAR COMPETENCY CRITERIA.', 'READY-TO-TEACH SESSIONS.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the tooth anatomy, histology and morphology visuals.', 'You already have the examination, radiology and diagnosis sequences.', 'You already have the preparation, materials and restorative techniques.', 'You already have the endodontic and periodontal procedure guides.', 'You already have the anesthesia, extraction and patient management protocols.', 'You already have the lesson plans, programs and competency assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-slate-200" data-id="element-68" data-mp="2164d1ipn7c5a">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="1wc06h0kah64q">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0F4C5C] mb-6 uppercase" data-id="element-70" data-mp="1v6be1b4zf7ro">
          You Don&apos;t Need More Scattered <span className="text-[#0B7A7A]" data-id="element-71" data-mp="203bl9pdkigkd">Dental Teaching Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1l6u9ix1guzxa">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q7869ixmang0">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#0F4C5C] tracking-wide" data-id="element-74" data-mp="1c7pdbxddnioa">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#F2F7F8] border border-slate-200 rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="36kyodtlknc8n">
          <p className="mb-4" data-id="element-76" data-mp="3bj06ab79h5ij">
            With DENTAL INSTRUCTOR ATLAS, you don&apos;t start every session searching through textbooks, slide
            decks, videos and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#0F4C5C] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="355vy6vb8h2t4">
              <Check size={18} className="text-[#0B7A7A] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v6ew0nv6x71w" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3sskjzs3d5ff0">
            And with the five exclusive bonuses, you also have tooth identification flashcards, clinical
            demonstration lesson scripts, typodont and simulation lab drills, radiograph interpretation practice
            cards and clinical competency rubrics with certificates to help you plan, teach, correct and assess
            your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0F4C5C]" data-id="element-80" data-mp="ffsd95shoh51">
            YOU ALREADY HAVE <span className="text-[#0B7A7A]" data-id="element-81" data-mp="alo3yfvr3x0s">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}